import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../Images/Qualified-Stucco-logo.png";
import "../Styles/Admin.css";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch("http://localhost:5000/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Login failed");
        setLoading(false);
        return;
      }

      localStorage.setItem("adminToken", data.token);
      localStorage.setItem("adminName", data.admin.name);
      navigate("/admin/dashboard");
    } catch (err) {
      setError("Server not available. Check backend connection.");
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      {/* Decorative elements */}
      <div className="admin-login-decor admin-login-decor-1"></div>
      <div className="admin-login-decor admin-login-decor-2"></div>
      <div className="admin-login-decor admin-login-decor-3"></div>

      <div className="admin-login-card">
        <div className="admin-login-header">
          <img src={Logo} alt="Qualified Stucco" className="admin-login-logo-img" />
          <h1>Welcome Back</h1>
          <p>Sign in to your admin dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && <div className="admin-error">{error}</div>}

          <div className="admin-form-group">
            <label>Email Address</label>
            <div className="admin-input-wrap">
              <span className="admin-input-icon">✉</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@qualifiedstucco.com"
                required
              />
            </div>
          </div>

          <div className="admin-form-group">
            <label>Password</label>
            <div className="admin-input-wrap">
              <span className="admin-input-icon">🔒</span>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
          </div>

          <button type="submit" className="admin-login-btn" disabled={loading}>
            {loading ? (
              <span className="admin-btn-loading">
                <span className="admin-btn-spinner"></span>
                Signing in...
              </span>
            ) : (
              "Sign In →"
            )}
          </button>
        </form>

        <div className="admin-login-footer">
          <p>Qualified Stucco Admin Panel</p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
